import React from 'react';
import Select from 'react-select';

const Forms = ({ label, placeholder, name, value, onChange }) => {
  return (
    <div className='mb-2'>
      <label className='form-label mb-1' style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 600, fontSize: '13.5px', color: '#334155' }}>
        {label}
      </label>
      <input
        name={name}
        placeholder={placeholder}
        className='form-control shadow-none'
        value={value}
        onChange={onChange}
        style={{
          borderRadius: '8px',
          border: '1.5px solid #cbd5e1',
          padding: '8px 12px',
          fontSize: '14.5px',
          fontFamily: 'Plus Jakarta Sans, sans-serif'
        }}
      />
    </div>
  );
};

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: '8px',
    borderColor: state.isFocused ? '#d90429' : '#cbd5e1',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(217, 4, 41, 0.15)' : 'none',
    '&:hover': {
      borderColor: '#d90429'
    },
    padding: '2px',
    fontSize: '14.5px',
    fontFamily: 'Plus Jakarta Sans, sans-serif'
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#d90429' : state.isFocused ? '#fee2e2' : 'transparent',
    color: state.isSelected ? '#ffffff' : '#1e293b',
    cursor: 'pointer',
    fontSize: '14px'
  })
};

const DropDowns = ({ options, placeholder, label, name, value, onChange }) => {
  return (
    <div className='mb-2'>
      <label className='form-label mb-1' style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 600, fontSize: '13.5px', color: '#334155' }}>
        {label}
      </label>
      <Select
        name={name}
        options={options}
        placeholder={placeholder}
        className='w-100'
        value={value}
        onChange={onChange}
        styles={customSelectStyles}
      />
    </div>
  );
};

export { Forms, DropDowns };